const styles = (theme) => ({
  root: {
    '&:not(:focus):not(:active)': {
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(100%)',
      height: 1,
      overflow: 'hidden',
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: 1,
    }
  },
});

export default styles;
